import React, { useState } from "react";
import InputFieldDataProfile from "../../../components/InputFieldDataProfile";
import SelectFieldDataProfile from "../../../components/SelectFieldDataProfile";
import editIcon from "../../../img/pencil-icon.svg";
import saveIcon from '../../../img/save-icon.svg';
import cancelIcon from '../../../img/close-icon-button.svg';

import { STATES } from "../../../constants";
import { Button, Box } from "@mui/material";
import { profileSchema } from "../../../validations/profileValidation";
import { useEffect } from "react";
import { useUpdateDataMutation } from '../../../services/accountsApi';

const ProfileAddress = ({ user, setUser }) => {
  const [initUpdateData, {isLoading: updateDataIsLoading}] = useUpdateDataMutation();

  function PencilOrangeIconSvg() {
    return <img src={editIcon} alt="edit icon" height="18px" width="18px" />;
  }

  const [userInformation, setUserInformation] = useState({ ...user });
  const [canEdit, setCanEdit] = useState(false);
  const [error, setError] = useState([]);

  useEffect(() => {
    setUserInformation((prev) => {
      return {
        ...user,
        address1: prev.address1,
        address2: prev.address2,
        city: prev.city,
        state: prev.state,
        zip: prev.zip
      }
    })
  }, [user])

  const closeEditForm = () => {
    setCanEdit(false);
    setUser({ ...userInformation })
  };


  async function onLocalSubmit() {
    try {

      await profileSchema.validate(userInformation, { abortEarly: false });
      setError([])
      sendData();
    } catch (err) {
      console.log(err.errors)
      console.log(err.name)
      if (err.name == "ValidationError") {
        setError(err.errors);
      }
    }
  }

  async function sendData() {

    try {
      setUser(await initUpdateData({id:user.id, body:userInformation}).unwrap())
    } catch (error) {
      setUserInformation({ ...user })
      console.log("error updating user: " + error);
    }

    closeEditForm();
  }


  return (
    <Box sx={{ display: "flex", flexDirection: "column"}}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
          <InputFieldDataProfile
            label="Address 1"
            value={userInformation.address1}
            onChange={(e) => { setUserInformation((prevState) => {return  { ...prevState, ['address1']: e.target.value }})}}
            edit={canEdit}
            sx={{marginRight: "5px"}}
          />

          <InputFieldDataProfile
            label="Address 2"
            value={userInformation.address2}
            onChange={(e) => { setUserInformation((prevState) => { return { ...prevState, ['address2']: e.target.value } }) }}
            edit={canEdit}
            sx={{marginRight: "5px"}}
          />

          <InputFieldDataProfile
            label="City"
            value={userInformation.city}
            onChange={(e) => { setUserInformation((prevState) => { return { ...prevState, ['city']: e.target.value } }) }}
            edit={canEdit}
            sx={{marginRight: "5px"}}
          />

          <SelectFieldDataProfile
            label="State"
            value={userInformation.state}
            options={STATES}
            onChange={(e) => { setUserInformation((prevState) => { return { ...prevState, ['state']: e.target.value } }) }}
            edit={canEdit}
            sx={{marginRight: "5px"}}
            menuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
          />

          <InputFieldDataProfile
            label="ZIP"
            value={userInformation.zip}
            onChange={(e) => { setUserInformation((prevState) => { return { ...prevState, ['zip']: e.target.value } }) }}
            edit={canEdit}
          />
        </Box>
        <Box className="edit-button-container">
          {canEdit ? (
            <div className="container-button-form">

              <Button onClick={onLocalSubmit} >
                <img src={saveIcon} alt='Save Icon' height='18px' style={{ marginRight: '0.25em' }} />
                <span style={{ color: ' var(--orange) ' }}>Save</span>
              </Button>

              <Button onClick={closeEditForm}>
                <img src={cancelIcon} alt='Cancel Icon' height='18px' style={{ marginRight: '0.25em' }} />
                <span style={{ color: ' var(--orange) ' }}>Cancel</span>
              </Button>

            </div>
          ) : (
            <Button onClick={() => setCanEdit(true)}>
              <PencilOrangeIconSvg />
              <span style={{ marginLeft: "0.5em", color: ' var(--orange) ' }}>Edit</span>
            </Button>
          )}
        </Box>
      </Box>
      <Box sx={{ display: "flex"}}>
        {error && error.length > 0 && <ul style={{ color: 'var(--red)' }} >
          {error.map((err) => (
            <li key={err}>{err}</li>
          ))}
        </ul>}
      </Box>
    </Box>

  )
}

export default ProfileAddress;
